import { render, staticRenderFns } from "./layout-eversec-angular.vue?vue&type=template&id=0b964f2a"
import script from "./layout-eversec-angular.vue?vue&type=script&lang=js"
export * from "./layout-eversec-angular.vue?vue&type=script&lang=js"
import style0 from "./layout-eversec-angular.vue?vue&type=style&index=0&id=0b964f2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports